import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {getLanguageOption, languageOptions} from 'utils/i18n/constants';

function useCurrentLanguage() {
  const {i18n} = useTranslation();

  return useMemo(
    () => getLanguageOption(i18n.language) || languageOptions[0],
    [i18n.language],
  );
}

export {useCurrentLanguage};
